import React from "react";
import { Box, Typography, Button } from "@mui/material";
import globalStyles from "../../../global";
import { useTranslation } from "react-i18next";

const FreeDeliveryBanner = () => {
  const { t } = useTranslation();
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

  const styles = {
    mainContainer: {
      width: "100%",
      maxWidth: "1200px",
      margin: { sm: "100px auto", xs: "50px auto" },
      position: "relative",
      borderRadius: "20px",
    },
    wrapper: {
      display: "flex",
      flexDirection: { xs: "column", lg: "row" },
      background:
        "linear-gradient(103.96deg, rgba(101, 186, 13, 0.5) -20.13%, rgba(173, 215, 129, 0.5) -20.13%, rgba(242, 243, 240, 0.5) 68.14%)",
      borderRadius: "20px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
      overflow: "visible",
      px: {
        sm: 8,
        xs: 2,
      },
      gap: {
        sm: 8,
        xs: 4,
      },
    },
    textSection: {
      width: "100%",
      flex: { md: "0 0 40%" },
      //  px: { xs: "16px", md: "32px" },
      py: "50px",

      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      textAlign: "left",
    },
    title: {
      // fontSize: getResponsiveSize({ xs: 22, md: 26 }),
      fontSize: {
        md: "45px",
        sm: "30px",
        xs: "26px",
      },
      fontWeight: 400,
      color: globalStyles.colors.army_green,
      fontFamily: globalStyles.fonts.primaryUAE,
      textTransform: "uppercase",
      lineHeight: "49px",
      letterSpacing: "1%",
    },
    subTitle: {
      // fontSize: getResponsiveSize({ xs: 22, md: 26 }),
      fontSize: {
        md: "45px",
        sm: "30px",
        xs: "26px",
      },
      fontWeight: 400,
      color: globalStyles.colors.army_green,
      fontFamily: globalStyles.fonts.primaryUAE,
      textTransform: "uppercase",
      lineHeight: "auto",
      letterSpacing: "1%",
    },
    amount: {
      // fontSize: getResponsiveSize({ xs: 28, md: 36 }),
      fontSize: {
        md: "45px",
        sm: "30px",
        xs: "26px",
      },
      fontWeight: 400,
      color: globalStyles.colors.uclean_green,
      fontFamily: globalStyles.fonts.primaryUAE,
      textTransform: "uppercase",
      lineHeight: "auto",
      letterSpacing: "1%",
    },
    button: {
      mt: 4,
      px: 3,
      py: 2,
      borderRadius: "10px",
      border: "1px solid #65BA0D",
      backgroundColor: "white",
      color: globalStyles.colors.uclean_green,
      fontWeight: 600,
      fontSize: "18px",
      fontFamily: "Poppins",
      lineHeight: "100%",
      letterSpacing: "0%",
      textTransform: "none",
      boxShadow: "0px 4px 4px 0px #00000014",
    },
    imageSection: {
      width: "100%",
      // flex: { md: "60%" },
      height: {
        xs: "200px",
        sm: "300px",
        md: "360px",
      },
      position: "relative",
      overflow: "visible",
    },
    image: {
      position: "absolute",
      height: {
        xs: "220px", // mobile
        sm: "320px", // tablet
        md: "400px", // desktop (unchanged)
      },
      objectFit: "contain",
      objectPosition: "right",
      display: "block",
      // transform: {
      //   xs: "translate(0%, 0%)",
      //   md: "translate(-5%)",
      // },
      // top: {
      //   // xs: "0px",
      //   sm: "20px",
      //   md: "-80px",
      // },
      bottom: 0,
      // right: {
      //   // xs: "20px",
      //   sm: "0",
      //   md: "100px",
      // },
      marginInline: "auto",
      width: "fit-content",
      // left: {
      //   sm: "0",
      // },
    },
  };

  return (
    <Box sx={styles.mainContainer}>
      <Box sx={styles.wrapper}>
        <Box sx={styles.textSection}>
          <Typography variant="h1" sx={styles.title}>
            {t("freeDelivery.title") + " " + t("freeDelivery.forOrdersAbove")}
          </Typography>
          {/* <Typography variant="h1" sx={styles.subTitle}>
            {t("freeDelivery.forOrdersAbove")}
          </Typography> */}
          <Typography variant="h1" sx={styles.amount}>
            {t("freeDelivery.amount", { amount: "500" })}
          </Typography>

          <Button sx={styles.button}>{t("freeDelivery.scheduleNow")}</Button>
        </Box>

        <Box sx={styles.imageSection}>
          <Box
            component="img"
            src={`${imageBaseUrl}freedelivery.png`}
            alt="Delivery person on a green scooter"
            sx={styles.image}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default FreeDeliveryBanner;
